// extracted by mini-css-extract-plugin
export default {"menuBlock":"OE-z","title":"PE-z","nav":"QE-z","flexCell":"RE-z","facetLink":"SE-z"};